/*!
 * frei nach ...
 *
 * tipso - A Lightweight Responsive jQuery Tooltip Plugin v1.0.8
 * Copyright (c) 2014-2015 Bojan Petkovski
 * http://tipso.object505.com
 * Licensed under the MIT license
 * http://object505.mit-license.org/
 */
// CommonJS, AMD or browser globals
(function (factory) {
  if (typeof define === "function" && define.amd) {
    // AMD. Register as an anonymous module.
    define(["jquery"], factory);
  } else if (typeof exports === "object") {
    // Node/CommonJS
    module.exports = factory(require("jquery"));
  } else {
    // Browser globals
    factory(jQuery);
  }
})(function ($) {
  let pluginName = "tipso",
    defaults = {
      speed: 200,
      background: "#ffffff",
      color: "#A4A4A4",
      position: "top",
      width: false,
      maxWidth: 380,
      delay: 200,
      hideDelay: 0,
      animationIn: "",
      animationOut: "",
      offsetX: 0,
      offsetY: -5,
      paddingX: 5,
      tooltipHover: true,
      content: null,
      ajaxContentUrl: null,
      ajaxContentBuffer: 0,
      contentElementId: null,
      useTitle: false,
      templateEngineFunc: null,
      onBeforeShow: null,
      onShow: null,
      onHide: null,
      imageDir: "",
      imageHover: false,
      imageOut: false
    };

  function Plugin(element, options) {
    this.element = element;
    this.$element = $(this.element);
    this.doc = $(document);
    this.win = $(window);
    this.settings = $.extend({}, defaults, options);

    if (typeof this.$element.data("tipso") === "object") {
      $.extend(this.settings, this.$element.data("tipso"));
    }

    let data_keys = Object.keys(this.$element.data());
    let data_attrs = {};
    for (let i = 0; i < data_keys.length; i++) {
      let key = data_keys[i].replace(pluginName, "");
      if (key === "") {
        continue;
      }
      key = key.charAt(0).toLowerCase() + key.slice(1);
      data_attrs[key] = this.$element.data(data_keys[i]);
      for (let settings_key in this.settings) {
        if (settings_key.toLowerCase() == key) {
          this.settings[settings_key] = data_attrs[key];
        }
      }
    }

    this._name = pluginName;
    this._title = this.$element.attr("title");
    this.mode = "hide";
    this.ieFade = !supportsTransitions;
    this.settings.preferedPosition = this.settings.position;

    this.move();
    this.init();
  }

  $.extend(Plugin.prototype, {
    move: function () {
      $e = this.$element;
      let moveleft = $e.data("tipso-moveleft");
      if (typeof moveleft !== "undefined") {
        $e.css("left", moveleft + "px");
      }
      let movetop = $e.data("tipso-movetop");
      if (typeof movetop !== "undefined") {
        $e.css({ position: "relative", top: movetop + "px" });
      }
    },
    init: function () {
      let obj = this,
        $e = this.$element;
      $e.addClass("tipso_style").removeAttr("title");

      if (obj.settings.tooltipHover) {
        let waitForHover = null,
          hoverHelper = null;
        $e.on("mouseover" + "." + pluginName, function () {
          clearTimeout(waitForHover);
          clearTimeout(hoverHelper);
          hoverHelper = setTimeout(function () {
            obj.show();
          }, 150);
        });
        $e.on("mouseout" + "." + pluginName, function () {
          clearTimeout(waitForHover);
          clearTimeout(hoverHelper);
          waitForHover = setTimeout(function () {
            obj.hide();
          }, 200);

          obj
            .tooltip()
            .on("mouseover" + "." + pluginName, function () {
              obj.mode = "tooltipHover";
            })
            .on("mouseout" + "." + pluginName, function () {
              obj.mode = "show";
              clearTimeout(waitForHover);
              waitForHover = setTimeout(function () {
                obj.hide();
              }, 200);
            });
        });
      } else {
        $e.on("mouseover" + "." + pluginName, function () {
          obj.show();
        });
        $e.on("mouseout" + "." + pluginName, function () {
          obj.hide();
        });
      }
      if (obj.settings.ajaxContentUrl) {
        obj.ajaxContent = null;
      }
    },
    tooltip: function () {
      if (!this.tipso_bubble) {
        this.tipso_bubble = $(
          '<div class="tipso_bubble"><div class="tipso_content"></div></div>'
        );
      }
      return this.tipso_bubble;
    },
    show: function () {
      let tipso_bubble = this.tooltip(),
        obj = this,
        $win = this.win;
      let bubble_pos_left = false;
      if ($win.width() - obj.settings.paddingX * 2 < obj.settings.maxWidth) {
        bubble_pos_left = true;
      }

      if (
        obj.settings.imageHover !== false &&
        obj.settings.imageOut !== false
      ) {
        obj.$element.attr(
          "src",
          obj.settings.imageDir.concat(obj.settings.imageHover)
        );
      }

      if (obj.mode === "hide") {
        if ($.isFunction(obj.settings.onBeforeShow)) {
          obj.settings.onBeforeShow(obj.$element, obj.element, obj);
        }
        if (obj.settings.maxWidth) {
          if (
            $win.width() - obj.settings.paddingX * 2 <
            obj.settings.maxWidth
          ) {
            obj.settings.maxWidth = $win.width();
          }
          if (obj.settings.width === true) {
            tipso_bubble
              .css({
                background: obj.settings.background,
                color: obj.settings.color,
                width: obj.settings.maxWidth
              })
              .hide();
          } else {
            tipso_bubble
              .css({
                background: obj.settings.background,
                color: obj.settings.color,
                "max-width": obj.settings.maxWidth
              })
              .hide();
          }
        } else {
          tipso_bubble
            .css({
              background: obj.settings.background,
              color: obj.settings.color,
              width: 400
            })
            .hide();
        }
        tipso_bubble.find(".tipso_content").html(obj.content());
        easyreposition(obj, bubble_pos_left);

        $win.on("resize" + "." + pluginName, function tipsoResizeHandler() {
          obj.settings.position = obj.settings.preferedPosition;
          easyreposition(obj, bubble_pos_left);
        });

        window.clearTimeout(obj.timeout);
        obj.timeout = null;
        obj.timeout = window.setTimeout(function () {
          if (
            obj.ieFade ||
            obj.settings.animationIn === "" ||
            obj.settings.animationOut === ""
          ) {
            tipso_bubble
              .appendTo("body")
              .stop(true, true)
              .fadeIn(obj.settings.speed, function () {
                obj.mode = "show";
                if ($.isFunction(obj.settings.onShow)) {
                  obj.settings.onShow(obj.$element, obj.element, obj);
                }
              });
          } else {
            tipso_bubble
              .remove()
              .appendTo("body")
              .stop(true, true)
              .removeClass("animated " + obj.settings.animationOut)
              .addClass("noAnimation")
              .removeClass("noAnimation")
              .addClass("animated " + obj.settings.animationIn)
              .fadeIn(obj.settings.speed, function () {
                $(this).one(
                  "webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend",
                  function () {
                    $(this).removeClass("animated " + obj.settings.animationIn);
                  }
                );
                obj.mode = "show";
                if ($.isFunction(obj.settings.onShow)) {
                  obj.settings.onShow(obj.$element, obj.element, obj);
                }
                $win.off(
                  "resize" + "." + pluginName,
                  null,
                  "tipsoResizeHandler"
                );
              });
          }
        }, obj.settings.delay);
      }
    },
    hide: function (force) {
      let obj = this,
        $win = this.win,
        tipso_bubble = this.tooltip(),
        hideDelay = obj.settings.hideDelay;

      if (
        obj.settings.imageHover !== false &&
        obj.settings.imageOut !== false
      ) {
        obj.$element.attr(
          "src",
          obj.settings.imageDir.concat(obj.settings.imageOut)
        );
      }

      if (force) {
        hideDelay = 0;
        obj.mode = "show";
      }

      window.clearTimeout(obj.timeout);
      obj.timeout = null;
      obj.timeout = window.setTimeout(function () {
        if (obj.mode !== "tooltipHover") {
          if (
            obj.ieFade ||
            obj.settings.animationIn === "" ||
            obj.settings.animationOut === ""
          ) {
            tipso_bubble
              .stop(true, true)
              .fadeOut(obj.settings.speed, function () {
                $(this).remove();
                if ($.isFunction(obj.settings.onHide) && obj.mode === "show") {
                  obj.settings.onHide(obj.$element, obj.element, obj);
                }
                obj.mode = "hide";
                $win.off(
                  "resize" + "." + pluginName,
                  null,
                  "tipsoResizeHandler"
                );
              });
          } else {
            tipso_bubble
              .stop(true, true)
              .removeClass("animated " + obj.settings.animationIn)
              .addClass("noAnimation")
              .removeClass("noAnimation")
              .addClass("animated " + obj.settings.animationOut)
              .one(
                "webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend",
                function () {
                  $(this)
                    .removeClass("animated " + obj.settings.animationOut)
                    .remove();
                  if (
                    $.isFunction(obj.settings.onHide) &&
                    obj.mode === "show"
                  ) {
                    obj.settings.onHide(obj.$element, obj.element, obj);
                  }
                  obj.mode = "hide";
                  $win.off(
                    "resize" + "." + pluginName,
                    null,
                    "tipsoResizeHandler"
                  );
                }
              );
          }
        }
      }, hideDelay);
    },
    close: function () {
      this.hide(true);
    },
    destroy: function () {
      let $e = this.$element,
        $win = this.win;
      $e.off("." + pluginName);
      $win.off("resize" + "." + pluginName, null, "tipsoResizeHandler");
      $e.removeData(pluginName);
      $e.removeClass("tipso_style").attr("title", this._title);
    },
    content: function () {
      let content,
        $e = this.$element,
        obj = this,
        title = this._title;
      if (obj.settings.ajaxContentUrl) {
        if (obj._ajaxContent) {
          content = obj._ajaxContent;
        } else {
          obj._ajaxContent = content = $.ajax({
            type: "GET",
            url: obj.settings.ajaxContentUrl,
            async: false
          }).responseText;
          if (obj.settings.ajaxContentBuffer > 0) {
            setTimeout(function () {
              obj._ajaxContent = null;
            }, obj.settings.ajaxContentBuffer);
          } else {
            obj._ajaxContent = null;
          }
        }
      } else if (obj.settings.contentElementId) {
        content = $("#" + obj.settings.contentElementId).html();
      } else if (obj.settings.content) {
        content = obj.settings.content;
      } else {
        if (obj.settings.useTitle === true) {
          content = title;
        } else {
          if (typeof $e.data("tipso") === "string") {
            content = $e.data("tipso");
          }
        }
      }
      if (obj.settings.templateEngineFunc !== null) {
        content = obj.settings.templateEngineFunc(content);
      }
      return content;
    },
    update: function (key, value) {
      let obj = this;
      if (value) {
        obj.settings[key] = value;
      } else {
        return obj.settings[key];
      }
    }
  });

  function realHeight(obj) {
    let clone = obj.clone();
    clone.css("visibility", "hidden");
    $("body").append(clone);
    let height = clone.outerHeight();
    let width = clone.outerWidth();
    clone.remove();
    return {
      width: width,
      height: height
    };
  }

  let supportsTransitions = (function () {
    let s = document.createElement("p").style,
      v = ["ms", "O", "Moz", "Webkit"];
    if (s["transition"] === "") return true;
    while (v.length) if (v.pop() + "Transition" in s) return true;
    return false;
  })();

  function easyreposition(thisthat, bubble_pos_left) {
    let tipso_bubble = thisthat.tooltip(),
      $e = thisthat.$element,
      obj = thisthat,
      $win = $(window),
      pos_top,
      pos_left,
      diff;

    if (bubble_pos_left === true) {
      tipso_bubble.css({
        left: 0 + obj.settings.offsetX
      });
    } else {
      if ($e.parent().outerWidth() > $win.outerWidth()) {
        $win = $e.parent();
      }
      pos_left =
        $e.offset().left +
        $e.outerWidth() / 2 -
        realHeight(tipso_bubble).width / 2;
      if (
        pos_left < $win.scrollLeft() &&
        (obj.settings.position === "bottom" || obj.settings.position === "top")
      ) {
        pos_left = 0;
      }
      if (
        pos_left + obj.settings.maxWidth > $win.outerWidth() &&
        (obj.settings.position === "bottom" || obj.settings.position === "top")
      ) {
        diff = $win.outerWidth() - (pos_left + obj.settings.maxWidth);
        pos_left = pos_left + diff;
      }
      tipso_bubble.css({
        left: pos_left + obj.settings.offsetX
      });
    }

    if ($e.parent().outerWidth() > $win.outerWidth()) {
      $win = $e.parent();
    }

    pos_top = $e.offset().top - realHeight(tipso_bubble).height;
    if (pos_top < $win.scrollTop()) {
      pos_top = $e.offset().top + $e.outerHeight() + -2 * obj.settings.offsetY;

      tipso_bubble.removeClass("top bottom left right");
      tipso_bubble.addClass("bottom");
    } else {
      tipso_bubble.removeClass("top bottom left right");
      tipso_bubble.addClass("top");
    }

    tipso_bubble.css({
      top: pos_top + obj.settings.offsetY
    });

    if (
      pos_top < $win.scrollTop() &&
      (obj.settings.position === "right" || obj.settings.position === "left")
    ) {
      $e.tipso("update", "position", "bottom");
      easyreposition(obj);
    }
    if (
      pos_top + realHeight(tipso_bubble).height >
        $win.scrollTop() + $win.outerHeight() &&
      (obj.settings.position === "right" || obj.settings.position === "left")
    ) {
      $e.tipso("update", "position", "top");
      easyreposition(obj);
    }
  }

  $[pluginName] = $.fn[pluginName] = function (options) {
    let args = arguments;
    if (options === undefined || typeof options === "object") {
      if (!(this instanceof $)) {
        $.extend(defaults, options);
      }
      return this.each(function () {
        if (!$.data(this, "plugin_" + pluginName)) {
          $.data(this, "plugin_" + pluginName, new Plugin(this, options));
        }
      });
    } else if (
      typeof options === "string" &&
      options[0] !== "_" &&
      options !== "init"
    ) {
      let returns;
      this.each(function () {
        let instance = $.data(this, "plugin_" + pluginName);
        if (!instance) {
          instance = $.data(
            this,
            "plugin_" + pluginName,
            new Plugin(this, options)
          );
        }
        if (
          instance instanceof Plugin &&
          typeof instance[options] === "function"
        ) {
          returns = instance[options].apply(
            instance,
            Array.prototype.slice.call(args, 1)
          );
        }
        if (options === "destroy") {
          $.data(this, "plugin_" + pluginName, null);
        }
      });
      return returns !== undefined ? returns : this;
    }
  };
});
